import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../services/apiService.service';
import { RootService } from '../../services/root.service';
import { ClevertapService } from '../../../shared/services/clevertap/clevertap.service';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { secureStorage } from '../../services/encryption/secureservice';
import { BehaviourSubjectService } from '../../services/behaviour-subject.service';
import * as unbxUrl from '../../../../assets/unbx-script.js';

declare var $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  headerMenu: any;
  sub: Subscription = new Subscription();
  trucksList: any;
  environment1 = environment.s3bucket.url;
  busesList: any;
  SCVPickupsList: any;
  subMenu: any[] = [];
  subMenuType: any;
  searchData: any;
  translatedValue: any = '';
  isUserLoggedIn: any;
  userData: any;
  isShowMenu: boolean = false;
  searchModels: any = [];
  sideFilter: any = [];
  mobileNo: any;
  isLoggedIn: boolean = false;
  menu: any = [];
  selectedMenu: any = [];
  selectedMenuIndex: any;
  isMobileBannerSearchShow: any = false;
  applicationData: any;
  applicationDataRes: any;
  segmentsData: any[];
  segmentsDataRes: any;
  productModelData: any;
  productModelDataRes: any;
  isMobile: boolean;
  dealerName: string;
  totalNoOfRecords;
  CategoryData: any = [];
  CategoryList: any = ['Trucks', "Buses", "Vans", "SCV Pickups"];
  selectedCategory: string = this.CategoryList[0];
  isTataEaseAvl: boolean = false;

  @ViewChild('searchInput') searchInput!: ElementRef;
  isDarkLogo: boolean = false;
  isLightLogo: boolean = true;
  searchValue: any;
  payloadfiresuggest: any = {};
  displaySearchDrp: boolean = false;
  fName: any;
  lName: any;
  constructor(
    private apiService: ApiService,
    private behaviorService: BehaviourSubjectService,
    private storageService: RootService,
    private router: Router, private route: ActivatedRoute,

    private localStorage: secureStorage,
    private toastrService: ToastrService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private cleverService: ClevertapService,
    private ApiService: ApiService
  ) { }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (isPlatformBrowser(this.platformId)) {
      const isHomeRoute = this.router.url.includes('/home');
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

      if (isHomeRoute) {
        if (scrollTop > 40) {
          $('.header').addClass('p-scroll');
          this.isDarkLogo = true;
          this.isLightLogo = false;
        } else {
          $('.header').removeClass('p-scroll');
          this.isLightLogo = true;
          this.isDarkLogo = false;
        }
      } else {
        $('.header').addClass('p-scroll');
        this.isDarkLogo = true;
        this.isLightLogo = false;
      }
    }
  }



  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.onWindowScroll();
        }
      });
      if (localStorage.getItem('isKeyAccountAvl') == 'true') {
        const Keymobileno = localStorage.getItem('isKeymobile');

        this.checkKeyAccount(Keymobileno);
      } else {
        this.isTataEaseAvl = false;
      }

      this.behaviorService.dealerName.subscribe(() => {
        this.dealerName = localStorage.getItem('dealername');
      });
      // this.dealerName = localStorage.getItem('dealername')

      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.isMobile = true;
        this.isLightLogo = false
        this.isDarkLogo = true;

      } else {
        this.isMobile = false;
      }

      $('.header').removeClass('p-scroll');
      this.sub.add(
        this.behaviorService.isLoggedIn.subscribe(() => {
          this.isUserLoggedIn = this.storageService.isLoggedIn() ? true : false;
          this.userData = this.storageService.getUserData();
          this.fName = this.userData?.first_name;
          this.lName =   this.userData.account_type === 'Individual' ? this.userData?.last_name ==='.' ? '' : this.userData?.last_name : '';

        })
      );

      this.route.queryParams.subscribe((params) => {
        if (
          this.router.url.includes('/product-list')
        ) {
          this.isLightLogo = false;
          this.isDarkLogo = true;
        }
      });

      $(document).ready(function () {
        $('a[href="#"]').attr('href', 'javascript:void(0)');
        $('.has-sub-menu').on('click', function () {
          $(this).find('ul.second-nav').addClass('active');
        });
        $('ul.second-nav .has-sub-menu').on('click', function () {
          $(this).find('ul.third-nav').addClass('active');
          $(this).find('ul.second-nav').removeClass('active');
        });
        $('.nav-close').on('click', function () {
          $('ul.second-nav').removeClass('active');
          $('ul.third-nav').removeClass('active');
        });
        $('.stepback').on('click', function () {
          if ($('ul.third-nav').hasClass('active')) {
            $('ul.third-nav').removeClass('active');
          } else {
            $('ul.second-nav').removeClass('active');
          }
        });
      });
    }
    // this.getBrandCategory('Trucks')
  }
  checkKeyAccount(Keymobileno: any) {
    if (isPlatformBrowser(this.platformId)) {
      let data = {
        ka_contact_number: Keymobileno,
      };
      this.sub.add(
        this.apiService.get_verify_ka_user(data).subscribe({
          next: (response: any) => {
            try {
              if (response.success) {
                this.isTataEaseAvl = true;
                localStorage.setItem('isKeyAccountAvl', 'true');
              } else {
                this.isTataEaseAvl = false;
                if (localStorage.getItem('isKeyAccountAvl')) {
                  localStorage.removeItem('isKeyAccountAvl');
                }
              }
            } catch (error) {
              console.error('Error processing response:', error);
            }
          },
          error: (error) => {
            console.error('API call failed:', error);
            this.isTataEaseAvl = false;
            localStorage.removeItem('isKeyAccountAvl');
          },
        })
      );
    }
  }

  callConfigurator() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.storageService.getUserData()) {
        localStorage.removeItem('VASData');
      } else {
        localStorage.setItem('previousUrl', '/configurator-home');
      }
    }
  }
  backMenu() {
    this.selectedMenu.splice(this.selectedMenuIndex, 1);
    this.selectedMenuIndex -= 1;
  }
  getTotalMenu(val: any, val2: any) {
    this.isDarkLogo = true;
    this.isLightLogo = false;
    this.isLightLogo ? (this.isLightLogo = false) : this.isDarkLogo;
    this.selectedMenuIndex = 0;
    if (val == 'trucks') {
      this.selectedMenu.push('Trucks');
    } else if (val == 'Buses') {
      this.selectedMenu.push('Buses');
    } else if (val == 'SCVPickups') {
      this.selectedMenu.push('SCV & Pickups');
    } else if (val == 'Vans') {
      this.selectedMenu.push('Vans');
    } else if (val == 'Brand') {
      this.selectedMenu.push('Brand');
    } else if (val == 'Category') {
      this.selectedMenu.push('Category');
    }
    this.menu = [];
    if (isPlatformBrowser(this.platformId)) {
      if (
        localStorage.getItem('menuItem') &&
        localStorage.getItem('menuItem').includes('data')
      ) {
        let response = JSON.parse(localStorage.getItem('menuItem'));
        this.headerMenu = response.data;
        this.trucksList = Object.keys(this.headerMenu.trucks); //Trucks menu
        this.busesList = Object.keys(this.headerMenu.buses); //Buses Menu
        this.SCVPickupsList = Object.keys(this.headerMenu.SCVPickups); //SVc Menu
        this.onSubMenuClick(val, val2, '');
        let key: any = Object.keys(this.headerMenu[val]);
        let values = Object.values(this.headerMenu[val]);
        for (let i = 0; i < key?.length; i++) {
          this.menu.push({
            name: key[i],
            display_name: values[i]['display_name'][0].name,
          });
        }
      } else {
        this.sub.add(
          this.apiService.getMenuItemList().subscribe({
            next: (response: any) => {
              localStorage.setItem('menuItem', JSON.stringify(response));
              this.headerMenu = response.data;
              this.trucksList = Object.keys(this.headerMenu.trucks); //Trucks menu
              this.busesList = Object.keys(this.headerMenu.buses); //Buses Menu
              this.SCVPickupsList = Object.keys(this.headerMenu.SCVPickups); //SVc Menu
              this.onSubMenuClick(val, val2, '');
              let key: any = Object.keys(this.headerMenu[val]);
              let values = Object.values(this.headerMenu[val]);
              for (let i = 0; i < key?.length; i++) {
                this.menu.push({
                  name: key[i],
                  display_name: values[i]['display_name'][0].name,
                });
              }
            },
            error: () => { },
            complete: () => { },
          })
        );
      }
    }
  }

  onSubMenuClick(value: any, value2: any, flag) {
    if (flag == 'html') {
      this.selectedMenuIndex = 1;
      this.selectedMenu.push(value2);
    }
    let subMenuList = this.headerMenu[value];
    this.subMenu =
      subMenuList[value2 ? value2 : Object.keys(subMenuList)[0]]?.ppl_list;
    this.subMenuType = value2;
  }
  gotoCategoryList(val1: any, val2: any) {
    {
      let sublob =
        val1 == 'Buses' ? 'Buses' : val1 == 'SCVPickups' ? 'scv-pickups' : val1;
      let lob = val2.replace(/\s+/g, '-')?.toLowerCase();
      this.router.navigate(['/category-list/' + sublob + '/' + lob]);
    }
  }
  onMenuClick(value: any, value1: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.isDarkLogo = true;
      this.isLightLogo = false;
      this.isLightLogo ? (this.isLightLogo = false) : this.isDarkLogo;
      let menuType: any;
      if (value === 'SCV Pickups') {
        menuType = this.subMenuType ? this.subMenuType : this.SCVPickupsList[0];
      }
      if (value === 'trucks') {
        menuType = this.subMenuType ? this.subMenuType : this.trucksList[0];
      }
      if (value === 'buses') {
        menuType = this.subMenuType ? this.subMenuType : this.busesList[0];
      }
      let lob_value = menuType.replace(/\s+/g, '-')?.toLowerCase();

      localStorage.removeItem('sideFilter');
      localStorage.removeItem("ExploreMappedData")
      localStorage.removeItem("ExploreMappedData1")
      localStorage.removeItem('ExploreMappedDatatype')
      localStorage.removeItem('ExploreMappedDatamodal')
      localStorage.removeItem("explore")
      localStorage.removeItem("EModeldData")
      localStorage.removeItem('UrlData');
      localStorage.removeItem('totalNoOfRecords');
      localStorage.removeItem('uniqueId');
      localStorage.removeItem('searchValue');
      localStorage.removeItem('filterValue');
      localStorage.removeItem('unbxFilterValue');
      this.behaviorService.filterValue.next('Header');
      this.behaviorService.isUnbxFilterChange.next(false);
      this.behaviorService.isSearch.next(false);
      this.behaviorService.callPlp.next(false);
      this.behaviorService.isClearfilter.next(false);
      let sub_lob =
        value.replace(/\s/g, '-')?.toLowerCase() == 'icv-trucks'
          ? 'trucks'
          : value.replace(/\s/g, '-')?.toLowerCase() == 'buses'
            ? 'buses-vans'
            : value.replace(/\s/g, '-')?.toLowerCase();
      let currentUrl =
        '/product-list/' +
        sub_lob.replace(/\s/g, '-')?.toLowerCase() +
        '/' +
        lob_value +
        '/' +
        value1;
      this.router.navigateByUrl(currentUrl);
      this.router
        .navigateByUrl('/home', { skipLocationChange: true })
        .then(() => {
          this.router.navigate([currentUrl]);
        });
      this.goTo();
    }
  }

  generateSeoFriendlyUrl(value: string, value1: string): string {
    let menuType: string = this.subMenuType ||
      (value === 'SCV Pickups' ? this.SCVPickupsList[0] :
        value === 'trucks' ? this.trucksList[0] :
          value === 'buses' ? this.busesList[0] : '');

    let lob_value = menuType.replace(/\s+/g, '-')?.toLowerCase();
    let sub_lob = value.replace(/\s/g, '-')?.toLowerCase();

    if (sub_lob === 'icv-trucks') sub_lob = 'trucks';
    if (sub_lob === 'buses') sub_lob = 'buses-vans';

    return `/product-list/${sub_lob}/${lob_value}/${value1}`;
  }

  clearState(event: any) {
    [
      'sideFilter', 'ExploreMappedData', 'ExploreMappedData1',
      'ExploreMappedDatatype', 'ExploreMappedDatamodal', 'explore',
      'EModeldData', 'UrlData', 'totalNoOfRecords',
      'uniqueId', 'searchValue', 'filterValue', 'unbxFilterValue'
    ].forEach(item => localStorage.removeItem(item));

    this.behaviorService.filterValue.next('Header');
    this.behaviorService.isUnbxFilterChange.next(false);
    this.behaviorService.isSearch.next(false);
    this.behaviorService.callPlp.next(false);
    this.behaviorService.isClearfilter.next(false);
  }

  onLoginClick() {
    this.sub.add(
      this.apiService.logoutApi('').subscribe({
        next: (res) => {
          if (this.isUserLoggedIn) {
            this.storageService.logout();
          } else {
            this.router.navigate(['/login/']);
            this.storageService.getFreeSearchToken()
          }
        },
        error: (err) => { },
      })
    );
  }
  getAutoSuggest(value: any) {
    if (value?.length >= 3) {
      this.displaySearchDrp = false;
      localStorage.removeItem('uniqueId');
      this.sub.add(
        this.apiService.getUnbxAutoSuggest(value).subscribe({
          next: (response: any) => {
            this.payloadfiresuggest = {};
            let data = response.response.products.filter(
              (res: any) => res.doctype == 'IN_FIELD'
            );
            var payload = {
              query: '',
              autosuggestParams: {
                autosuggest_type: response?.response?.searchMetaData
                  ?.queryParams?.q
                  ? response?.response?.searchMetaData?.queryParams?.q
                  : '',
                autosuggest_suggestion: response?.response?.searchMetaData
                  ?.queryParams?.q
                  ? response?.response?.searchMetaData?.queryParams?.q
                  : '',
                field_name: response?.response?.products?.model
                  ? response?.response?.products?.model
                  : '',
                field_value: data[0]?.autosuggest ? data[0]?.autosuggest : '',
                src_field: '',
                internal_query: data[0]?.autosuggest
                  ? data[0]?.autosuggest
                  : '',
              },
            };
            this.payloadfiresuggest = payload;
            // unbxUrl.fireAutoSuggest(payload)
          },
          error(err) { },
          complete() { },
        })
      );
    } else {
      return;
    }
    this.getSearchModels(value);
  }

  getSearchModels(value: any) {
    // localStorage.removeItem('sideFilter')
    if (this.searchData?.length == 0) {
      this.isMobileBannerSearchShow = true;
    } else {
      this.isMobileBannerSearchShow = false;
    }
    if (value?.length >= 3) {
      this.sub.add(
        this.apiService.getsearchUnbxd(value).subscribe({
          next: (response: any) => {
            this.searchModels = [];
            this.sideFilter = [];
            // let totalNoOfRecords = response.response.numberOfProducts
            localStorage.removeItem('totalNoOfRecords');
            this.totalNoOfRecords = response.response.numberOfProducts;
            this.searchValue = response.searchMetaData.queryParams.q;
            localStorage.setItem('searchValue', this.searchValue);
            // this.behaviorService.searchval.next(searchValue);
            response.response.products.forEach((res: any) => {
              if (this.searchModels?.length <= 9) {
                this.searchModels.push(res);
              }
            });
            this.sideFilter = response.facets.text.list;
            // this.localStorage.setItem('sideFilter', JSON.stringify(this.sideFilter))
            // this.behaviorService.isUnbxFilterChange.next(true);
          },

          error: () => {
            this.toastrService.warning('Something went wrong!');
          },
          complete: () => { },
        })
      );
    } else if (value?.length == 0) {
      this.searchModels = [];
      this.sideFilter = [];
    } else {
      return;
    }
  }
  searchAll() {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobileBannerSearchShow = true;
      this.displaySearchDrp = true;
      let uniqueId = [];
      let data;
      localStorage.removeItem('uniqueId');
      localStorage.removeItem('sideFilter');
      localStorage.removeItem('unbxFilterValue');
      localStorage.removeItem('normalFilterValue');
      if (this.searchModels?.length > 0) {
        for (let i = 0; i < this.searchModels?.length; i++) {
          data = this.searchModels[i].uniqueId;
          uniqueId.push(data);
        }
        localStorage.setItem('uniqueId', JSON.stringify(uniqueId));
        localStorage.setItem('totalNoOfRecords', this.totalNoOfRecords);
        this.localStorage.setItem(
          'sideFilter',
          JSON.stringify(this.sideFilter)
        );
        this.behaviorService.isUnbxFilterChange.next(true);
        this.behaviorService.callPlp.next(true);
      }
      localStorage.removeItem("ExploreMappedData")
      localStorage.removeItem("ExploreMappedData1")
      localStorage.removeItem('ExploreMappedDatatype')
      localStorage.removeItem('ExploreMappedDatamodal')
      localStorage.removeItem("explore")
      localStorage.removeItem("EModeldData")
      localStorage.setItem('searchValue', this.searchValue);
      setTimeout(() => {
        this.behaviorService.searchval.next(this.searchValue);
      }, 100);
      this.behaviorService.isSearch.next(true);
      unbxUrl.fireAutoSuggest(this.payloadfiresuggest);
      this.router.navigate(['/product-list/']);
      this.behaviorService.isFilterChange.next(false);
      this.isMobileBannerSearchShow = true;
      this.searchInput.nativeElement.blur();
    }
  }


  searchSingle(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.displaySearchDrp = true;
      localStorage.removeItem('uniqueId');
      localStorage.removeItem('unbxFilterValue');
      localStorage.removeItem('normalFilterValue');
      try {
        data = data.replace(/\//g, ' ');
        this.cleverService.onFindBySearch('Application', data);
      } catch (error) { }
      this.searchData = data.uniqueId ? data.uniqueId : data;
      let unbxValue = data.uniqueId ? true : false;
      if (!(data.uniqueId ? data.uniqueId : data)) {
        return;
      } else {
        let userdata = {
          data: [data.uniqueId ? data.uniqueId : data],
          isBulk: false,
          ignoreTaggedEntities: true,
          domain: 1,
          convertNumber: 'Local',
        };
        this.sub.add(
          this.apiService.getTranslateText(userdata).subscribe({
            next: (response: any) => {
              if (response.responseList[0]?.apiStatus == 2) {
                this.translatedValue = response.responseList[0]?.outString[0];
                this.behaviorService.isUnbxFilterChange.next(true);
                this.gotoProdList(this.translatedValue, unbxValue);
              }
            },
            error: () => {
              this.gotoProdList(data, unbxValue);
            },
            complete: () => { },
          })
        );
      }
    }
  }
  selectSearchResult(data: string) {
    this.searchData = data;
  }

  openBusinessDetailsModal() {
    if (isPlatformBrowser(this.platformId)) {
      $('#businessDetailsModal').modal('show');
    }
  }

  gotoProdList(searchval: any, unbxValue: any) {
    if (isPlatformBrowser(this.platformId)) {
      if (unbxValue) {
        localStorage.removeItem('totalNoOfRecords');
        this.localStorage.setItem(
          'sideFilter',
          JSON.stringify(this.sideFilter)
        );
        this.behaviorService.isUnbxFilterChange.next(true);
      }
      localStorage.removeItem("ExploreMappedData")
      localStorage.removeItem("ExploreMappedData1")
      localStorage.removeItem('ExploreMappedDatatype')
      localStorage.removeItem('ExploreMappedDatamodal')
      localStorage.removeItem("explore")
      localStorage.removeItem("EModeldData")
      this.behaviorService.isSearch.next(true);
      unbxUrl.fireAutoSuggest(this.payloadfiresuggest);
      this.router.navigate(['/product-list/' + searchval.trim()]);
      this.behaviorService.isFilterChange.next(false);
    }
  }



  clickEvent(sub_lob: any, lob: any) {
    sub_lob = sub_lob.replace(/\s/g, '-')?.toLowerCase();
    lob = lob.replace(/\s/g, '-')?.toLowerCase();
    var currentUrl = '/category-list/' + sub_lob + '/' + lob;
    return currentUrl;
  }
  redirect(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      if (this.isUserLoggedIn) {
        if (data == 'wishList') {
          this.router.navigate(['/account/wishList']);
        }
        if (data == 'notifications') {
          this.router.navigate(['/account/notifications']);
        }
      } else {
        localStorage.setItem('previousUrl', this.router.url);
        this.router.navigate(['/login']);
      }
    }
  }

  SectionClick(sectioname: any) {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.OnSectionClick(sectioname);
      } catch { }
    }
  }

  onEService(type) {
    if (isPlatformBrowser(this.platformId)) {
      if (type == 'AMC') {
        if (this.isUserLoggedIn) {
          this.router.navigate(['/e-services']);
        } else {
          localStorage.setItem('previousUrl', '/e-services');
          this.router.navigate(['/login/']);
        }
      }
    }
  }

  showMobileBannerSearch(flag) {
    this.isMobileBannerSearchShow = flag;
    if (this.isMobile) {
      if (!this.applicationDataRes) {
        this.getApplicationData();
      }
      if (!this.segmentsDataRes) {
        this.getSegmentsData('');
      }
      if (!this.productModelDataRes) {
        this.getProductModelData('');
      }
    }
  }
  onFocusOutRemoveSpace() {
    this.searchData = '';
    this.searchModels = [];
    // this.sideFilter = [];
  }
  goTo() {
    var element = document.getElementById('closeBtnMobile');
    element.click();
  }

  getApplicationData() {
    let data = {
      sub_lob: 'ALL',
    };
    this.sub.add(
      this.ApiService.getAllApplications(data).subscribe({
        next: (res: any) => {
          this.applicationData = res.data;
          this.applicationDataRes = res.data;
        },
        error: () => { },
        complete: () => { },
      })
    );
  }
  getSegmentsData(value: any) {
    let data = {
      vehicle_application: value,
    };
    this.sub.add(
      this.ApiService.getSegment(data).subscribe({
        next: (res: any) => {
          this.segmentsData = [];
          res.data.lob.forEach((res) => {
            this.segmentsData.push({ eleName: res, img_url: '' });
          });
          this.segmentsDataRes = res.data.lob;
          if (isPlatformBrowser(this.platformId)) {
            if (
              localStorage.getItem('menuItem') &&
              localStorage.getItem('menuItem').includes('success')
            ) {
              let response = JSON.parse(localStorage.getItem('menuItem'));
              var result = Object.keys(response.data).map((key) => [
                key,
                response.data[key],
              ]);
              result.forEach((element) => {
                for (const key in element[1]) {
                  let i = this.segmentsData.findIndex((x) => x.eleName == key);
                  if (i >= 0) {
                    this.segmentsData[i].img_url =
                      element[1][key]['ppl_list'][0].image;
                  }
                }
              });
            } else {
              this.sub.add(
                this.ApiService.getMenuItemList().subscribe({
                  next: (response: any) => {
                    localStorage.setItem('menuItem', JSON.stringify(response));
                    var result = Object.keys(response.data).map((key) => [
                      key,
                      response.data[key],
                    ]);
                    result.forEach((element) => {
                      for (const key in element[1]) {
                        let i = this.segmentsData.findIndex(
                          (x) => x.eleName == key
                        );
                        if (i >= 0) {
                          this.segmentsData[i].img_url =
                            element[1][key]['ppl_list'][0].image;
                        }
                      }
                    });
                  },
                  error: () => { },
                  complete: () => { },
                })
              );
            }
          }
        },
        error: () => { },
        complete: () => { },
      })
    );
  }
  getProductModelData(value: any) {
    let data = {
      lob: value,
      offset: 0,
      limit: 10,
    };
    this.sub.add(
      this.ApiService.getModelList(data).subscribe({
        next: (res: any) => {
          this.productModelData = res.data.models;
          this.productModelDataRes = res.data.models;
        },
        error: () => { },
        complete: () => { },
      })
    );
  }
  bannerSearch(flag, value) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('isMobileBannerSearch', 'true');
      localStorage.removeItem("ExploreMappedData")
      localStorage.removeItem("ExploreMappedData1")
      localStorage.removeItem('ExploreMappedDatatype')
      localStorage.removeItem('ExploreMappedDatamodal')
      localStorage.removeItem("explore")
      localStorage.removeItem("EModeldData")
      let vehicle_application = '';
      let actual_lob_name = [];
      let model = [];
      if (flag == 'Application') vehicle_application = value;
      if (flag == 'Segment') actual_lob_name = [value];
      if (flag == 'Model') model = [value];
      this.showMobileBannerSearch(false);
      this.router.navigate(['product-list'], {
        queryParams: { vehicle_application, actual_lob_name, model },
      });
    }
  }
  goToHomePage() {
    this.router.navigate(['/home']);
  }
  getBrandCategory(val: any) {
    this.selectedCategory = val;
    let data = {
      action_type: 'BRAND',
      category: 'BRAND',
      sub_lob: val,
    };
    this.apiService.getBannerVideoData(data).subscribe({
      next: (res: any) => {
        //  this.CategoryData=res.data.banner_data
        this.CategoryData = res.data.filter((item) => item.path !== null);
      },
      error: () => { },
      complete: () => { },
    });
  }
  Clickcat(data: any) {
    this.selectedCategory = data;
    this.getBrandCategory(data);
  }
  gotobrand(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('uniqueId');
      this.router.navigate(['/brand', data?.toLowerCase()]);
      this.behaviorService.isSmart.next(false);
    }
  }
  gotoCategory(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('uniqueId');
      this.router.navigate(['/category', data === 'Trucks' ? 'trucks' : data]);
    }
  }
  goToadvancesearch() {
    this.router.navigate(['/advancesearch']);
  }
  omit_special_char(event) {
    var k;
    k = event.charCode;
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }
  onKeyPressspace(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    if (input.selectionStart === 0 && event.key === ' ') {
      event.preventDefault();
    }
  }
  getLoyalitySignup() {
    if (this.isUserLoggedIn) {
      const data = {
        mobile_number: this.userData?.mobile_number,
        first_name: this.userData?.first_name,
        last_name: this.userData?.firstlast_name_name,
        email_id: this.userData?.first_name.email_id,
        created_source: "OSP",
        // user_type: "Customer",
        // user_tier: "Gold",
        // kyc: "Aadhar"
      };
      try {

        this.sub.add(
          this.apiService.signUpLoyality(data).subscribe({
            next: (res) => {
              if (res.success) {

              } else {
              }
            },
            error: (err) => {
            },
            complete: () => {
            },
          })
        );
      } catch (error) { }
    }
  }
  ngAfterViewInit() {
    this.onWindowScroll();
  }
}
